export default "/assets/images/mila-feed-08.mp4?cd3817d39d1c7156fea84df7354850a6";